"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingScore = void 0;
require("../../scss/rating/rating.scss");
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const ratingUnitType_1 = require("./models/ratingUnitType");
const RatingScore = ({ ratingScore, ratingCount }) => {
    const TOTAL_SCORE = 5;
    const roundToHalfRatingScore = Math.round(ratingScore * 2) / 2;
    const getClassName = (currentIndex) => {
        if (currentIndex <= roundToHalfRatingScore) {
            return ratingUnitType_1.RatingUnitType.COMPLETE;
        }
        else if (currentIndex - roundToHalfRatingScore == 0.5) {
            return ratingUnitType_1.RatingUnitType.HALF;
        }
        else {
            return ratingUnitType_1.RatingUnitType.EMPTY;
        }
    };
    return (react_1.default.createElement("div", { className: "boutik-package-components-rating-score-container" },
        lodash_1.default.times(TOTAL_SCORE, (index) => (react_1.default.createElement("div", { key: index, className: `boutik-package-components-rating-${getClassName(index + 1)}` }))),
        ratingCount && react_1.default.createElement("h1", { className: "boutik-package-components-rating-count" }, `(${ratingCount})`)));
};
exports.RatingScore = RatingScore;
//# sourceMappingURL=RatingScore.js.map